import { Box, styled } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

export const FilledStarIcon = styled(StarIcon)({
  color: 'rgb(255, 233, 102)',
});

export const EmptyStarIcon = styled(StarBorderIcon)({
  color: 'rgb(255, 233, 102)',
});

export const BoxStar = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  border: 'none',
  background: 'none',
  margin: '0 auto',
  padding: '0',
  '&:hover': {
    cursor: 'pointer',
  },
});
